"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NPCMovementSystem = void 0;
const Constants_1 = require("../../../Shared/Constants");
const gotti_1 = require("gotti");
class NPCMovementSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.NPC_MOVEMENT);
        this.movingNPCs = [];
    }
    moveBaddy(baddyId, x, y) {
        const c = this.getSystemComponent(this.$api.findBaddy(baddyId));
        c && c.moveTo(x, y);
    }
    onClear() { }
    onStart() {
        this.addApi(this.moveBaddy);
        //  this.globals.tileWorld.addColliderCouples([[COLLIDER_TAGS.NPC_HITBOX, COLLIDER_TAGS.CLIENT_OWNED_PROJECTILE]])
    }
    onStop() {
        //   this.globals.tileWorld.removeColliderCouples([[COLLIDER_TAGS.NPC_HITBOX, COLLIDER_TAGS.CLIENT_OWNED_PROJECTILE]])
    }
    onLocalMessage(message) {
        switch (message.type) {
        }
    }
    onPeerMessage(peerId, message) {
    }
    onEntityAddedComponent(entity, component) {
        entity['$moveTo'] = component.moveTo.bind(component);
        this.movingNPCs.push(entity);
    }
    onEntityRemovedComponent(entity, component) {
        for (let i = 0; i < this.movingNPCs.length; i++) {
            if (this.movingNPCs[i] === entity) {
                this.movingNPCs.splice(i, 1);
                return;
            }
        }
    }
    update(delta) {
        for (let i = 0; i < this.movingNPCs.length; i++) {
            const baddy = this.movingNPCs[i];
            const mc = this.getSystemComponent(baddy);
            if (!mc) {
                //console.error(baddy, this);
                throw new Error(`Expected movement component`);
            }
            //TODO: fix mobster1 animation so we dont need to inverse it or need the additional inverse logic anywhere(also done somewhere in the npc attack system)
            mc.updateMovement(delta); //: { x?: number, y?: number, movingDirectionIndex?: number, lookingDirectionIndex: number } {
        }
    }
    onServerMessage(message) {
        throw new Error("Method not implemented.");
    }
}
exports.NPCMovementSystem = NPCMovementSystem;
//# sourceMappingURL=module.js.map